import React, { useState } from 'react'

const FormTip = (props) => {
    const [isView, setIsView] = useState(false);

    const icon =  require("../../images/question_square.svg");

    // 説明文
    const ViewDescription = () =>{
        if(typeof props.description != 'undefined'){
            const texts = props.description.split('¥n').map((value) => {
                return(<>{value}<br/></>)
            })
            return texts
        }else{
            return <></>
        }
    }

    // 画像
    const ViewImages = () =>{
        if(typeof props.images != 'undefined'){
            const images = props.images.map((url) => {
                return(<><img className="w100p" src={url}/><br/></>)
            })
            return images
        }else{
            return <></>
        }
    }
    
    return(
        <>
            <div>
                {props.children}
                <img src={icon} className="ml5 pointer" onClick={() => setIsView(isView ? false : true)}/>
            </div>
            { isView && <div className="form-tip-top mb5" ><ViewDescription/><ViewImages/></div> }
        </>
    )
}
export default FormTip;